import { Box } from '@mui/material'
import React, { useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import { WizardContent } from './wizard-items'
import WizardStepper from './wizard-items/WizardStepper'
import { WizardStepModel } from './types'

const DEFAULT_ACTIVE_STEP = 0

const useStyles = makeStyles()(theme => ({
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
    padding: `${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(1)}`,
    [theme.breakpoints.down('sm')]: {
      padding: `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(1)}`,
    },
  },
}))

interface Props {
  steps: WizardStepModel[]
  isLastStepValid: boolean
  onConfirm: () => void
  className?: string
}

/**
 * A wizard where the current's step content is displayed at the top with a stepper bar below.
 * @param steps the steps to move through
 * @param validationArray a boolean array of length @steps where true means a step is validated as ok
 */
const Wizard: React.VFC<Props> = ({ steps, isLastStepValid, onConfirm, className }) => {
  const { classes, cx } = useStyles()
  const [activeStep, setActiveStep] = useState(DEFAULT_ACTIVE_STEP)

  return (
    <Box className={cx(classes.container, className)}>
      <WizardContent activeStep={activeStep} content={steps[activeStep].content} />
      <WizardStepper steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} isLastStepValid={isLastStepValid} onConfirm={onConfirm} />
    </Box>
  )
}

export default Wizard
